import { Injectable } from '@angular/core';

declare let gtag:Function; // Declare ga as a function

/*

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

*/
@Injectable()
export class GoogleAnalyticsService {

  constructor() { }

  

  public eventEmitter( 
    evtName: string, 
    evtCategory: string, 
    evtAction: string, 
    evtLabel: string , 
    evtValue: number  ){ 
        gtag('event', evtName, { 
        event_category: evtCategory, 
        event_label: evtLabel, 
        action: evtAction, 
        value: evtValue
        })
     }


}
